import { Component, Input } from '@angular/core';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-worker-report',
  templateUrl: './worker-report.component.html',
  styleUrls: ['./worker-report.component.scss']
})
export class WorkerReportComponent {

  @Input() reportId: string;
  @Input() list: [];
  companyLogo: CompanyLogoConfiguration = null;

  date = new Date();
  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }

  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }
}
